<template>

    <div class="container" style="padding-top: 30px;">

        <BlockUI v-if="blockUI" message="Prosimo počakajte trenutek..." url="/images/loading-spinner.svg"></BlockUI>

        <div class="row">

            <div class="col-md-8 col-md-offset-2">


                <div class="panel panel-default">


                    <form-wizard
                            title="Prijavnica"
                            subtitle=" "
                            shape="tab"
                            color="#3a3d3f"
                            error-color="#a94442"
                            ref="prijavnica"
                            id="checkout"
                    >


                        <div id="orderSummary">

                            <div class="table">
                                <div id="items">
                                    <div class="row item">
                                        <div class="col-sm-12">
                                            Plačilo obroka v znesku <b>{{ formatNumber(price) }}€</b>
                                        </div>
                                        <div></div>
                                    </div>
                                    <div class="row item">
                                        <div class="col-sm-12">
                                            Število obrokov
                                            <b>{{ order.payments }}</b>
                                        </div>
                                        <div></div>
                                    </div>
                                    <div class="row item">
                                        <div class="col-sm-12">
                                            Že plačano:
                                            <b>{{ formatNumber(order.paid) }}€</b> (od {{ formatNumber(order.price_total) }}€)
                                        </div>
                                        <div></div>
                                    </div>
                                    <div class="row item">
                                        <div class="col-sm-12">
                                            Preostalo za plačilo:
                                            <b>{{ formatNumber(order.price_total - order.paid) }}€</b>
                                        </div>
                                        <div></div>
                                    </div>
                                    <div class="row item">
                                        <div class="col-sm-12">
                                            Datum naslednjega obroka:
                                            <b>{{ formatDate(order.next_payment) }}</b>
                                        </div>
                                        <div></div>
                                    </div>
                                    <div class="row item">
                                        <div class="col-sm-12">
                                            Danes za plačilo:
                                            <b>{{ formatNumber(price) }}€</b>
                                        </div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>

                            <hr>


                        </div>

                        <tab-content title="Povzetek naročila">
                            <div>
                                <div id="dropin-container"></div>
                            </div>

                        </tab-content>

                        <template slot="footer" slot-scope="props">


                            <div class="wizard-footer-right">


                                <wizard-button
                                        :disabled="submit_button === false"
                                        @click.native="submitPayment()"
                                        class="wizard-footer-right finish-button">
                                    Plačilo obroka ({{formatNumber(price)}}€)
                                </wizard-button>


                            </div>
                        </template>
                    </form-wizard>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import VueFormWizard from 'vue-form-wizard';
    import BlockUI from 'vue-blockui'
    import moment from 'moment'

    Vue.use(VueFormWizard);

    Vue.use(BlockUI);


    //    import "vue-form-generator/dist/vfg-core.css";  // optional core css additions
    //    import 'vue-form-wizard/dist/vue-form-wizard.min.css';


    export default {

        props: ["order", 'price', "braintree_client_token", "submit_url", "env"],


        data: function () {
            return {
                // moment: moment,
                blockUI: false,

                submit_button: false,
                braintree: {
                    dropinInstance: null
                },

            }
        },


        mounted() {
            this.braintreeInit();
        },

        created() {

        },


        methods: {

            formatNumber(num) {
                /**
                 * @see https://stackoverflow.com/questions/6134039/format-number-to-always-show-2-decimal-places
                 */
                return parseFloat(Math.round(num * 100) / 100).toFixed(2);
            },
            formatDate(date) {
                return moment(date).format("DD.MM.YYYY");
            },

            braintreeInit() {
                var submitButton = document.querySelector('#submit-button');

                var self = this;

                braintree.dropin.create({
                    authorization: this.braintree_client_token,
                    selector: '#dropin-container',
                    paypal: {
                        flow: 'checkout',
                        amount: this.price,
                        currency: 'EUR'
                    },
                    translations: {
                        payingWith: '{{paymentSource}}',
                        chooseAnotherWayToPay: 'Izberite drug način plačila',
                        chooseAWayToPay: 'Izberite način plačila',
                        otherWaysToPay: 'Izberite drug način plačila',
                        edit: 'Urejaj',
                        doneEditing: 'Zaključi',
                        editPaymentMethods: 'Urejaj način plačila',
                        CreditCardDeleteConfirmationMessage: 'Delete {{secondaryIdentifier}} card ending in {{identifier}}?',
                        PayPalAccountDeleteConfirmationMessage: 'Odstrani PayPal račun {{identifier}}?',
                        VenmoAccountDeleteConfirmationMessage: 'Are you sure you want to delete Venmo account with username {{identifier}}?',
                        genericDeleteConfirmationMessage: 'Ali ste prepričani, da želite odstraniti ta način plačila?',
                        deleteCancelButton: 'Prekliči',
                        deleteConfirmationButton: 'Odstrani',
                        cardVerification: 'Verifikacija kartice',
                        // Errors
                        fieldEmptyForCvv: 'Prosimo vpišite CVV (to 3-mestno številko najdete na zadnji strani kartice).',
                        fieldEmptyForExpirationDate: 'Prosimo vpišite datum poteka.',
                        fieldEmptyForCardholderName: 'Prosimo vpišite ime in priimek lastnika kartice.',
                        fieldEmptyForNumber: 'Prosimo vpišite številko kartice.',
                        fieldEmptyForPostalCode: 'Prosimo vpišite poštno številko.',
                        fieldInvalidForCvv: 'CVV številka je napačna',
                        fieldInvalidForExpirationDate: 'Datum poteka je napačen.',
                        fieldInvalidForNumber: 'Številka kartice ni veljavna.',
                        fieldInvalidForPostalCode: 'This postal code is not valid.',
                        fieldTooLongForCardholderName: 'Ime lastnika mora vsebovati manj kot 256 znakov',
                        genericError: 'Prišlo je do napake na našem koncu. Se iskreno opravičujemo. Če se napaka ponavlja, nas kontaktirajte.',
                        hostedFieldsTokenizationFailOnDuplicateError: 'This credit card already exists as a saved payment method.',
                        hostedFieldsFailedTokenizationError: 'Prosimo preverite vpisane podatke in poizkusite ponovno.',
                        hostedFieldsTokenizationCvvVerificationFailedError: 'Verifikacija kartice ni bila uspešna. Prosimo preverite vpisane podatke in poizkusite ponovno.',
                        hostedFieldsTokenizationNetworkErrorError: 'Napaka v omrežju. Prosimo poizkusite ponovno.',
                        hostedFieldsFieldsInvalidError: 'Prosimo preverite vpisane podatke in poizkusite ponovno.',
                        paypalButtonMustBeUsed: 'Uporabite PayPal gumb za dokončanje plačila.',
                        paypalAccountTokenizationFailedError: 'Prišlo je do napake pri dodajanju PayPal računa. Prosimo poizkusite ponovno.',
                        paypalFlowFailedError: 'Prišlo je do napake pri povezavi s PayPalom. Prosimo poizkusite ponovno.',
                        paypalTokenizationRequestActiveError: 'PayPal avtorizacija je že v procesu.',
                        applePayTokenizationError: 'A network error occurred while processing the Apple Pay payment. Prosimo poizkusite ponovno.',
                        applePayActiveCardError: 'Add a supported card to your Apple Pay wallet.',
                        vaultManagerPaymentMethodDeletionError: 'Unable to delete payment method, try again.',
                        venmoCanceledError: 'Something went wrong. Ensure you have the most recent version of the Venmo app installed on your device and your browser supports switching to Venmo.',
                        venmoAppFailedError: 'The Venmo app could not be found on your device.',
                        unsupportedCardTypeError: 'Žal naš sistem ne podpira tega tipa kartice. Prosimo uporabite drugo kartico.',
                        // Card form
                        cardholderNameLabel: 'Ime in Priimek',
                        cardNumberLabel: 'Številka kartice',
                        cvvLabel: 'CVV',
                        cvvThreeDigitLabelSubheading: '(3 številke)',
                        cvvFourDigitLabelSubheading: '(4 številke)',
                        expirationDateLabel: 'Datum poteka',
                        expirationDateLabelSubheading: '(MM/LL)',
                        cardholderNamePlaceholder: 'Ime in Priimek',
                        expirationDatePlaceholder: 'MM/LL',
                        postalCodeLabel: 'Poštna številka',
                        payWithCard: 'Plačajte s kartico',
                        // Payment Method descriptions
                        endingIn: 'Kartica {{lastFourCardDigits}}',
                        Card: 'Kartica',
                        PayPal: 'PayPal',
                        'PayPal Credit': 'PayPal Credit',
                        'Apple Pay': 'Apple Pay',
                        'Google Pay': 'Google Pay',
                        'Venmo': 'Venmo',
                        'American Express': 'American Express',
                        Discover: 'Discover',
                        'Diners Club': 'Diners Club',
                        MasterCard: 'Mastercard',
                        Visa: 'Visa',
                        JCB: 'JCB',
                        Maestro: 'Maestro',
                        UnionPay: 'UnionPay'
                    }
                }, this.braintreeCallback);
            },
            braintreeCallback(err, dropinInstance) {

                this.braintree.dropinInstance = dropinInstance;

                let self = this;

                this.braintree.dropinInstance.on('paymentMethodRequestable', function (event) {
                    self.submit_button = true;
                }.bind(self));

                this.braintree.dropinInstance.on('noPaymentMethodRequestable', function () {
                    self.submit_button = false;
                }.bind(self));

                if (err) {
                    // Handle any errors that might've occurred when creating Drop-in
                    console.error(err);
                }

            },
            submitPayment() {

                let self = this;

                this.braintree.dropinInstance.requestPaymentMethod(function (err, payload) {
                    if (err) {
                        // Handle errors in requesting payment method
                        if (err.message === 'No payment method is available.') {
                            alert('Prosimo najprej izberite način plačila. V primeru, da ste izbrali PayPal, kliknite na rumen PayPal gumb.');
                        }
                        console.warn(err);
                        return;
                    }

                    self.blockUI = true;

                    axios.post(laroute.route("placilo.obrok.process", {order_uid: self.order.uid}), {
                        amount: self.price,
                        payload: payload
                    })
                        .then(function (response) {

                            if (response.data.success === true) {
                                // redirect
                                window.location = laroute.route("placilo.obrok.success", {order_uid: self.order.uid});
                            } else {
                                alert(response.data.message);
                                self.braintree.dropinInstance.clearSelectedPaymentMethod();
                                self.blockUI = false;
                            }

                        })
                        .catch(function (error) {
                            console.warn(error);
                            alert('Prišlo je do napake. Prosimo poizkusite ponovno. V primeru, da se napaka ponavlja, nas prosim kontaktirajte');
                            self.blockUI = false;
                        });

                }.bind(self));

            },

        },


        computed: {},


    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/installments/pay.vue